module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c19"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 1280")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter01"
  }, [_vm._v("Fractional Distillation")]), _vm._v(" "), _c('p', {
    staticClass: "seealso_fm2"
  }, [_c('strong', [_vm._v("Taddeo Alderotti")]), _vm._v(" (c. 1210–1295)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Distillation was originally used to liberate some liquid fraction from solids, but the next step in this process was to separate liquids with different boiling points from one another. To achieve this, the mixture had to be heated slowly and passed through a longer distilling apparatus, or column, making sure that the more volatile parts were brought over first. Heat things too vigorously, though, and the lower-boiling molecules end up mixing with the higher-boiling molecules as they distill over, and everything has to be done again. Naturally, the closer the boiling points, the more patience is needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The thirteenth-century Florentine alchemist Taddeo Alderotti seems to be the first person to describe fractional distillation in detail in the final section of his "), _c('em', [_vm._v("Consilia medicinalia")]), _vm._v(" (c. 1280). Famous for his medical knowledge, he used a three-foot-long apparatus to distill alcohol to a purity of 90 percent for strictly medical purposes. His work led to a profusion of different still types and a great deal of experimentation with other substances to see what could be purified from them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In time, the theory of distillation became better understood, with advances in alcohol production often helping to move things along. The design of the so-called "), _c('em', [_vm._v("still head")]), _vm._v(" showed the greatest improvement, as fractionating columns provided greater surface areas for the vapor and condensate to mix, leading to better separations. Distillation is still extremely important both industrially and on a laboratory scale. It is one of the basic purification techniques for water and for industrial solvents, it is the fundamental technology behind the fractionation of oil in a refinery, and it remains the key to the making of high-proof alcoholic beverages. Some things never change.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c05"
    }
  }, [_vm._v("Purification (c. 1200 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thermal Cracking (1891)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liquid Air (1895)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deuterium (1931)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rotary Evaporator (1950)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/051.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A decorative (but not very practical) look at fractional distillation of “spirits of wine” by German surgeon and alchemist Hieronymous Brunschwig, 1512. In the middle, “a tube of cold water” condenses the vapors.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70752ede","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c19.vue
// module id = 132
// module chunks = 0